import React from "react"

export const Title = ({ title }) => (
  <header>
    <h1 className="hide">{title}</h1>
  </header>
)
